
import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import css from './ReceiptTable.module.css'

const format = {
  date: (input) => moment(input).format('MMM Do, YYYY'),
  money: (input) => numeral(input).format('$0,0.00')
}

const ReceiptTable = props => (
  <div className={css.main}>
    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Amount (in U.S. dollars)</th>
        </tr>
      </thead>
      <tbody>
        {lines(props)}
      </tbody>
      <tfoot>
        <tr>
          <th>Total</th>
          <th>{format.money(props.amount)}</th>
        </tr>
      </tfoot>
    </table>
  </div>
)

function lines (payment) {
  if (payment.invoiceLines) {
    const lines = payment.invoiceLines.map(renderRow)

    if (payment.amountCredit) {
      lines.push(renderRow({
        description: 'Credit Used',
        amount: -payment.amountCredit
      }))
    }

    return lines
  } else if (payment.description || payment.invoiceDescription) {
    return [
      renderRow({
        description: payment.description || payment.invoiceDescription,
        amount: payment.amount
      })
    ]
  }
}

/**
 * Render a table row from `line`.
 */

function renderRow (line) {
  const period = line.periodStart
    ? <span> ({format.date(line.periodStart)} - {format.date(line.periodEnd)})</span>
    : null

  return (
    <tr>
      <td>
        <span>{line.description}</span>
        {period}
      </td>
      <td>{format.money(line.amount)}</td>
    </tr>
  )
}

export default ReceiptTable



// WEBPACK FOOTER //
// ./components/ReceiptTable.js